import { render, staticRenderFns } from "./PlayerDetail.vue?vue&type=template&id=4c18b6ca&"
import script from "./PlayerDetail.vue?vue&type=script&lang=ts&"
export * from "./PlayerDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports